import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { saveWAShareLinkMessage, getWaitingAreaShareLinkMessage } from 'actions/waitingArea';
import { showWAShareLinkMessageModal } from 'actions/modal';
import { displayGlobalMessage } from 'actions/globalMessage';
import Info from '../../info';

const RightPanel = (props) => {
  const dispatch = useDispatch();
  const [savingChanges, setSavingChanges] = useState(false);

  const closeModal = () => {
    dispatch(showWAShareLinkMessageModal(false));
  };

  const saveChange = () => {
    if (!props.textMessageValidState.valid || !props.emailMessageValidState.valid) {
      return;
    }
    setSavingChanges(true);
    let cb = (result, err) => {
      if (result) {
        setSavingChanges(false);
        dispatch(showWAShareLinkMessageModal(false));
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.WaitingAreaShareLink.SuccessMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      } else {
        setSavingChanges(false);
        if (err === 'FeatureNotAllowed' || err === 'NoWaitingAreaEditPermission' || err === 'NoNetworkEditPermission') {
          dispatch(showWAShareLinkMessageModal(false));
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.ShareLinkSharedText.PermissionChange,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              gotItButtonText: APP.LANGUAGE.ShareLinkSharedText.Refresh,
              gotItCallBack: () => {
                window.location.reload();
              },
            })
          );
        } else if (err === 'StaffEditNotAllowedFromOrgAdmin') {
          dispatch(showWAShareLinkMessageModal(false));
          dispatch(
            displayGlobalMessage({
              text: APP.LANGUAGE.ShareLinkSharedText.ServiceAdminEditNotAllowed,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Bad,
              autoHide: false,
              gotItButtonText: APP.LANGUAGE.ShareLinkSharedText.TryAgain,
              gotItCallBack: () => {
                dispatch(
                  getWaitingAreaShareLinkMessage(props.waitingAreaId, () => {
                    dispatch(showWAShareLinkMessageModal(true));
                  })
                );
              },
            })
          );
        }
      }
    };
    let payload = {
      additionalEmailMessage: props.additionalEmailMessage,
      additionalTextMessage: props.additionalTextMessage,
      staffCanEditMessages: props.canEditMessages,
    };
    dispatch(saveWAShareLinkMessage(props.waitingAreaId, payload, cb));
  };

  let saveClasses =
    'ui labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull ' +
    (!props.textMessageValidState.valid || !props.emailMessageValidState.valid ? 'disable' : '');

  return (
    <React.Fragment>
      <Container fluid as={Media} greaterThanOrEqual="tablet">
        {props.updateOrView === 'update' ? (
          <div className="mrts mrbl max-width">
            <button
              tabIndex="4"
              type="button"
              name="saveBtn"
              data-group="createOrgUnitForm"
              className={savingChanges ? saveClasses + ' loading' : saveClasses}
              onClick={saveChange}
            >
              {APP.LANGUAGE.Save}
              <i className="checkmark icon" />
            </button>
            <button
              tabIndex="5"
              type="button"
              onClick={closeModal}
              className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
            >
              <i className="remove  icon" />
              {APP.LANGUAGE.Cancel}
            </button>
          </div>
        ) : (
          <div className="mrts mrbl max-width">
            <button
              tabIndex="4"
              type="button"
              onClick={closeModal}
              className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
            >
              <i className="remove  icon" />
              {APP.LANGUAGE.Cancel}
            </button>
          </div>
        )}
        <div className="mrtl">
          <Info
            paragraphs={[APP.LANGUAGE.ShareLinkSharedText.InfoText1, APP.LANGUAGE.WaitingAreaShareLink.InfoText2]}
          />
        </div>
      </Container>
      <Container fluid as={Media} at="mobile">
        {props.updateOrView === 'update' ? (
          <div className="display-flex mrts mrbs max-width pdlm pdrm">
            <button
              tabIndex="4"
              type="button"
              name="saveBtn"
              data-group="createOrgUnitForm"
              className={
                (savingChanges ? saveClasses + ' loading' : saveClasses) + ' mobile-fixed-footer-btn mrbs mrrm'
              }
              onClick={saveChange}
            >
              {APP.LANGUAGE.Save}
              <i className="checkmark icon" />
            </button>
            <button
              tabIndex="5"
              type="button"
              onClick={closeModal}
              className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mobile-fixed-footer-btn"
            >
              <i className="remove  icon" />
              {APP.LANGUAGE.Cancel}
            </button>
          </div>
        ) : (
          <div className="display-flex mrts mrbs max-width pdlm pdrm">
            <button
              tabIndex="5"
              type="button"
              onClick={closeModal}
              className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull mobile-fixed-footer-btn"
            >
              <i className="remove  icon" />
              {APP.LANGUAGE.Cancel}
            </button>
          </div>
        )}
      </Container>
    </React.Fragment>
  );
};

export default RightPanel;
